import { render, staticRenderFns } from "./investRecord.vue?vue&type=template&id=67dc41f0&scoped=true"
import script from "./investRecord.vue?vue&type=script&lang=js"
export * from "./investRecord.vue?vue&type=script&lang=js"
import style0 from "./investRecord.vue?vue&type=style&index=0&id=67dc41f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc41f0",
  null
  
)

export default component.exports